// @ts-nocheck
import { AbstractCoworkOperationMessage } from "./AbstractCoworkOperationMessage";

export class CoworkOperationMessage extends AbstractCoworkOperationMessage {
  constructor() {
    super();
  }
}
